/**
 * useHashNavigation - Custom hook for cross-page hash navigation
 * Handles navigation to home page sections from any page
 */

import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export const useHashNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateToHash = useCallback((hashTarget, offset = 0) => {
    const isOnHomePage = location.pathname === '/';
    
    const scrollToElement = () => {
      const element = document.getElementById(hashTarget);
      if (element) {
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset + offset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    };

    if (isOnHomePage) {
      // Direct scroll on home page
      scrollToElement();
    } else {
      // Navigate to home page first
      navigate('/', { replace: true });
      
      // Wait for navigation and DOM update, then scroll
      setTimeout(scrollToElement, 150);
    }
  }, [navigate, location.pathname]);

  return navigateToHash;
};
